import lodash from 'lodash'
import {
  formatAmount,
  formatDateShort,
  formatTags,
} from '@/utils/formatting'

export const createPurchaseBtn = (clickFn) => {
  return {
    label: 'Purchase',
    type: 'purchase',
    data: {
      name: 'purchase',
    },
    click: clickFn,
  };
};

export const purchaseModalData = (categories, businesses, tags) => {
  return {
    headerText: 'Add Purchase',
    inputs: [
      { name: 'date', label: 'Date', type: 'date' },
      { name: 'amount', label: 'Amount', type: 'number', step: '0.01' },
      {
        name: 'category',
        label: 'Category',
        type: 'text',
        options: categories,
      },
      {
        name: 'business',
        label: 'Business',
        type: 'text',
        options: businesses,
      },
      { name: 'desc', label: 'Description', type: 'textarea' },
      { 
        name: 'tag_list',
        label: 'Tags',
        type: 'tag_input',
        tagList: tags,
        alignment: 'vertical',
      },
    ],
  };
};

export const createPurchaseRows = (purchases = []) => {
  return purchases.map(p => ({
    ...p,
    link: {
      name: 'purchase',
      params: { id: p?.id },
    },
    cells: [
      {
        id: 'date',
        value: formatDateShort(p?.date),
        classes: 'cell-small',
        isLink: true,
      },
      {
        id: 'amount',
        value: formatAmount(p?.amount),
        classes: 'cell-small right',
      },
      {
        id: 'business',
        value: p?.business?.name,
        classes: 'cell-medium',
      },
      {
        id: 'category',
        value: p?.category?.name,
        classes: 'cell-medium',
      },
      {
        id: 'details',
        value: lodash.truncate(p?.desc),
        classes: 'cell-xlarge',
        isLink: true,
      },
      {
        id: 'tags',
        value: formatTags(p?.tags || []),
        classes: 'cell-xlarge',
        isHtml: true,
      },
    ]
  }))
}
